<div class="product">
  <div class="product-image" [ngClass]="{'disabled': disable}" data-tooltip="Ask your rep">
    <img [src]="imageUrl" alt="title" (click)="onClick()">
  </div>

  <button class="product-button btn btn-primary btn-fill" (click)="onClick()">{{ title }}</button>
</div>
